import React from 'react';
import styled from 'styled-components';
import { Button } from '@dls/react-core';
import { ColorX11 } from '../../styling/color';

interface ActionProps {
  close: () => void;
}

const StyledNotiStackButton = styled(Button)`
  color: ${ColorX11.White} !important;
`;

export const NotiStackAction: React.FC<ActionProps> = ({ close }) => {
  return <StyledNotiStackButton onClick={() => close()}>Close</StyledNotiStackButton>;
};
